import { useEffect } from "react";

function Loading() {

  const checkHE = async () => {
  try {
          // ✅ NEW
           const res = await fetch("/HE");

    const text = await res.text();
    console.log("HE RAW:", text);

    // 🔥 MSISDN extract (IMPORTANT FIX)
    const match = text.match(/MSISDN=(\d+)/);

    if (match && match[1]) {
      const msisdn = match[1];

      console.log("MSISDN DETECTED:", msisdn);

      localStorage.setItem("msisdn", msisdn);
      return msisdn;
    }

    console.log("❌ MSISDN NOT FOUND");
    return null;

  } catch (err) {
    console.log("HE failed:", err.message);
    return null;
  }
};

  useEffect(() => {
    const init = async () => {
      const offerCode = localStorage.getItem("offerCode");

      if (!offerCode) {
        window.location.href = "/signin";
        return;
      }

      // 🔥 STEP 1: HE detect
      let msisdn = await checkHE();

      // 🔥 STEP 2: fallback (अगर HE fail)
      if (!msisdn) {
        msisdn = localStorage.getItem("msisdn");
      }

      // ❗ still नहीं मिला → signin
      if (!msisdn) {
        window.location.href = "/signin?fallback=true";
        return;
      }

      // 🔥 STEP 3: backend call
      let url = "/api/cgw/generate-url?offerCode=" + offerCode + "&msisdn=" + msisdn;

      console.log("FINAL URL:", url);

      window.location.href = url;
    };

    init();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-black text-white">
      <div className="text-center">
        <div className="animate-spin h-12 w-12 border-4 border-yellow-400 border-t-transparent rounded-full mx-auto mb-4"></div>
        <p>Detecting ...</p>
      </div>
    </div>
  );
}

export default Loading;